import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.date.to-string";
import "core-js/modules/es6.object.to-string";
var currentId = 0;
export function generateId() {
  currentId += 1;
  return currentId.toString();
}
export function resetId() {
  currentId = 0;
}